var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/status/containers/quoted-status-container.tsx";
import React, { useCallback } from 'react';
import QuotedStatus from 'soapbox/components/quoted-status';
import { useAppSelector } from 'soapbox/hooks';
import { makeGetStatus } from 'soapbox/selectors';

const QuotedStatusContainer = _ref => {
  let {
    statusId
  } = _ref;
  const getStatus = useCallback(makeGetStatus(), []);
  const status = useAppSelector(state => getStatus(state, {
    id: statusId
  }));

  if (!status) {
    return null;
  }

  return /*#__PURE__*/React.createElement(QuotedStatus, {
    status: status,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 5
    }
  });
};

export default QuotedStatusContainer;